// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1A7Lu","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1WL8A"};